import qs from 'query-string'
import cx from 'classnames'
import { Fragment, useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { isUndefined, last } from 'lodash'

import { Link, useNavigate } from 'features/i18n/router'
import { appendList, st } from 'lib/helpers'
import { useGetHimanowUsersQuery } from 'store/api/yay/user'
import { User } from 'lib/_types'
import { useInfinityScrollSimple, useScroll } from 'hooks'
import { snowplowEvent } from 'lib/analytics'

import LoadMore from 'components/LoadMore'
import AsyncListDataComponent from 'components/AsyncListDataComponent'
import SeoHeader from 'components/SEOHeader'
import { HimanowUserList } from 'components'

const HimanowModal = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [__fromId, __fromIdSet] = useState<string>('0')
  const [__himanowUsers, __himanowUsersSet] = useState<Array<User>>([])
  const ref = useRef<HTMLDivElement>(null)
  const { diff } = useScroll({ target: ref })

  const himanowUsersRes = useGetHimanowUsersQuery({
    fromHimaId: __fromId,
  })

  const loadMore = () => {
    __fromIdSet(last(__himanowUsers)?.['_hima_id']?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __himanowUsersSet((prevState) => {
      return appendList(prevState, himanowUsersRes?.data, '')
    })
  }, [himanowUsersRes])

  useEffect(() => {
    snowplowEvent.scroll({ diff })
  }, [diff])

  const shouldGoBackWhenClose = !isUndefined(qs.parse(location.search)?.goBack)

  return (
    <Fragment>
      <SeoHeader
        description={st('himanow.description')}
        title={st('himanow.title')}
      />
      <div className="Modal__wrapper">
        <div className="Modal__header">
          <Link
            className={cx('Modal__header__close', {
              'Modal__header__close--back': shouldGoBackWhenClose,
            })}
            to={location.pathname}
            onClick={(e) => {
              if (shouldGoBackWhenClose) {
                e.preventDefault()
                navigate(-1)
              }
            }}
          />

          <h2 className="Modal__header__h2">{t('common.himanow_user')}</h2>
        </div>

        <div className="Modal__body" ref={ref}>
          <AsyncListDataComponent
            isLoading={himanowUsersRes?.isLoading}
            isLoaded={himanowUsersRes?.isSuccess}
            data={__himanowUsers}
          >
            {(himanowUsers: Array<User>) => {
              return (
                <Fragment>
                  <HimanowUserList users={himanowUsers} mode="list" fullWidth />

                  <LoadMore
                    isLoading={himanowUsersRes?.isFetching}
                    className="LoadMore--bd-t"
                    hidden={(himanowUsersRes?.data?.length ?? 0) == 0}
                    onClick={loadMore}
                    ref={loadMoreRef}
                  />
                </Fragment>
              )
            }}
          </AsyncListDataComponent>
        </div>
      </div>
    </Fragment>
  )
}

export default HimanowModal
